import React, { useState, useEffect } from "react";
import { 
  Info, AlertTriangle, CheckCircle, ClipboardCheck, 
  ShieldCheck, Trash, XCircle, CheckCircle2, MailCheck, QrCode, Clock, Phone
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronUp, ChevronDown } from "lucide-react";
import { Copy } from "lucide-react";
import { RotateCcw } from "lucide-react";
import SMS from './SMS';


import { CalendarDays, CalendarCheck } from "lucide-react";

function UberAccount({ darkMode }) {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [qrVisible, setQrVisible] = useState({});
  const [emailVerification, setEmailVerification] = useState({});
  const [selectedDiscount, setSelectedDiscount] = useState('all');
  const [copiedItem, setCopiedItem] = useState(null);
  const [total404Count, setTotal404Count] = useState(0);
  const [timeFilter, setTimeFilter] = useState({ start: "", end: "" });
  const [successMessage, setSuccessMessage] = useState("");
  
  // 成功提示自動消失
  useEffect(() => {
    const timer = setTimeout(() => {
      setSuccessMessage("");
    }, 2000);
    return () => clearTimeout(timer);
  }, [successMessage]);
  
  
  // 新增modal相關狀態
  const [modal, setModal] = useState({
    isOpen: false,
	isProcessing: false, // 新增處理狀態
    type: 'info', // info | confirm
    title: '',
    content: '',
    onConfirm: null,
    confirmText: '確認',
    cancelText: '取消'
  });

// 首先优化 ModernModal 组件中的过渡动画效果
const ModernModal = () => {
  const iconMap = {
    info: <Info className="w-7 h-7 text-blue-400" />,
    confirm: <ShieldCheck className="w-7 h-7 text-yellow-600" />,
    delete: <Trash className="w-7 h-7 text-red-400" />,
    warning: <AlertTriangle className="w-7 h-7 text-yellow-400" />,
    success: <CheckCircle className="w-7 h-7 text-green-400" />,
    clock: <Clock className="w-7 h-7 text-green-400" />
  };

  return (
    <AnimatePresence mode="wait">
      {modal.isOpen && (
       <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ 
            opacity: 0,
            transition: { duration: 0.2, delay: 0.1 } // 添加消失延遲
          }}
          className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
        >
          {/* 玻璃質感背景 - 优化点击非模态区域关闭效果 */}
          <motion.div
            className="absolute inset-0 bg-gradient-to-br from-black/30 to-purple-900/15 backdrop-blur-lg"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
          />

          {/* 模態主體動畫優化 */}
          <motion.div
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ 
              scale: 1, 
              opacity: 1, 
              y: 0,
              transition: { type: "spring", stiffness: 400, damping: 25 }
            }}
            exit={{
              scale: 0.95,
              opacity: 0,
              y: -10,
              transition: {
                duration: 0.2,
                ease: "easeInOut"
              }
            }}
            className="relative w-full max-w-md"
          >
            <div className={`
              rounded-2xl p-8 relative overflow-hidden
              ${
                darkMode
                  ? 'bg-[#2A2A2A] border border-white/5 shadow-2xl shadow-black/40'
                  : 'bg-white border border-gray-100 shadow-2xl shadow-gray-200/30'
              }`}
            >
              {/* 裝飾性漸變光帶 */}
              <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-sky-400 to-purple-500 opacity-20" />

              {/* 標題區域 */}
              <div className="flex items-start gap-5 mb-6">
                <div className={`
                  p-3 rounded-xl border shadow-inner
                  ${darkMode ? 'bg-white/5 border-white/10' : 'bg-gray-100 border-gray-200'}
                `}>
                  {iconMap[modal.iconType] || iconMap.info}
                </div>

                <div className="space-y-1">
                  <h3 className={`text-2xl font-bold tracking-tight ${darkMode ? 'text-gray-100' : 'text-gray-800'}`}>
                    {modal.title}
                  </h3>
                  <motion.p
                    initial={{ opacity: 0, y: 5 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: 0.1 }}
                    className={`text-base leading-relaxed ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}
                  >
                    {modal.content}
                  </motion.p>
                </div>
              </div>

              {/* 操作按鈕 */}
              <div className="flex justify-end gap-3 mt-8">
                {modal.type === 'confirm' && (
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    disabled={modal.isProcessing}
                    onClick={() => setModal(p => ({ ...p, isOpen: false }))}
                    className={`
                      px-5 py-2.5 rounded-lg font-medium transition-colors
                      ${darkMode ? 'text-gray-300 hover:bg-white/5' : 'text-gray-600 hover:bg-gray-100'}
                    `}
                  >
                    {modal.cancelText}
                  </motion.button>
                )}
				

				  
				<motion.button
				  whileHover={{ scale: modal.isProcessing ? 1 : 1.05 }}
				  whileTap={{ scale: modal.isProcessing ? 1 : 0.95 }}
				  disabled={modal.isProcessing}
				  onClick={modal.onConfirm}
                  className={`
                    px-5 py-2.5 rounded-lg font-medium shadow-lg relative overflow-hidden
                    ${
                      darkMode
                        ? 'bg-gradient-to-r from-sky-500/90 to-purple-500/90 hover:from-sky-400/90 hover:to-purple-400/90'
                        : 'bg-gradient-to-r from-sky-500 to-purple-500 hover:from-sky-400 hover:to-purple-400'
                    } text-white transition-all duration-300 flex items-center justify-center
                  `}
				>
				  {modal.isProcessing ? (
					<div className="flex items-center gap-2">
					  <motion.div
						animate={{ rotate: 360 }}
						transition={{ repeat: Infinity, duration: 0.8 }}
						className="w-5 h-5 rounded-full border-2 border-t-transparent"
					  />
					  <span>{modal.confirmText}</span>
					</div>
				  ) : (
					<span>{modal.confirmText}</span>
				  )}
				</motion.button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

// 优化 showFeedback 函数，使其处理确认后自动关闭
const showFeedback = (type, title, message, onConfirm, iconType = 'info') => {
  setModal({
    isOpen: true,
    isProcessing: false,  // 初始状态
    type: type === 'confirm' ? 'confirm' : 'info',
    iconType,
    title,
    content: message,
    confirmText: type === 'info' ? '好的' : '確認',
    cancelText: '取消',
    onConfirm: async () => {
      if (!onConfirm) {
        setModal(prev => ({ ...prev, isOpen: false }));
        return;
      }

      try {
        // 保持模态框开启，只更新处理状态
        setModal(prev => ({
          ...prev,
          isProcessing: true,
          confirmText: '處理中...',
          cancelText: '', // 隐藏取消按钮
          onConfirm: null // 禁用重复点击
        }));

        await onConfirm();

        // 直接关闭模态框
        setModal(prev => ({
          ...prev,
          isOpen: false,
          isProcessing: false
        }));

      } catch (error) {
        // 错误时更新当前模态框内容
        setModal(prev => ({
          ...prev,
          isProcessing: false,
          iconType: 'warning',
          title: '發生錯誤',
          content: error.message,
          confirmText: '好的',
          type: 'info',
          onConfirm: () => setModal(prev => ({ ...prev, isOpen: false }))
        }));
      }
    }
  });
};

useEffect(() => {
  let accountInterval;
  let countInterval;

  if (!modal.isOpen) {
    accountInterval = setInterval(fetchAccounts, 5000);
    countInterval = setInterval(fetch404Count, 5000);
  }

  return () => {
    clearInterval(accountInterval);
    clearInterval(countInterval);
  };
}, [modal.isOpen]);
  
  // 新增：获取404订单总数
  const fetch404Count = async () => {
    try {
      const res = await fetch("https://api.mcvanuatu.com/api/accounts/count-discount-type-404");
      if (!res.ok) throw new Error("獲取訂單總數失敗");
      setTotal404Count(await res.json());
    } catch (err) {
      console.error("錯誤:", err);
    }
  };
  
  
  
  
  // 新增：时间范围筛选逻辑
const filteredCount = accounts.filter(acc => {
  // 转换为 UTC 的开始时间和结束时间
  const startOfDay = timeFilter.start
    ? new Date(`${timeFilter.start}T00:00:00`) // 昨天 00:00:00 (UTC)
    : null;

  const endOfDay = timeFilter.end
    ? new Date(`${timeFilter.end}T23:59:59`) // 今天 23:59:59 (UTC)
    : null;

  // 过滤逻辑
  return (
    acc.discountType === 404 &&
    (startOfDay === null || new Date(acc.keepTime) >= startOfDay) &&
    (endOfDay === null || new Date(acc.keepTime) <= endOfDay)
  );
}).length;
  
// 在组件顶部添加日期处理函数
const getLocalDateString = (date) => {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .split('T')[0];
};


// 在组件中添加useEffect
useEffect(() => {
  if (timeFilter.start && (!timeFilter.end || timeFilter.end < timeFilter.start)) {
    setTimeFilter(prev => ({
      ...prev,
      end: timeFilter.start
    }));
  }
}, [timeFilter.start]);


	const handleCopy = async (text, id, type) => {
	  try {
		await navigator.clipboard.writeText(text);
		setCopiedItem({ id, type }); // 保存當前卡片的 id 和類型
		setTimeout(() => setCopiedItem(null), 1500); // 1.5 秒後重置
	  } catch (err) {
		console.error("複製失敗:", err);
	  }
	};

  
  // 獲取帳戶數據
  const fetchAccounts = async () => {
    try {
      const response = await fetch("https://api.mcvanuatu.com/api/accounts/availableAccount");
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      data.sort((a, b) => new Date(a.createdTime) - new Date(b.createdTime));
      setAccounts(data);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };


  
// 保留帳戶函數 (优化)
const handleKeepAccount = async (id) => {
  showFeedback('confirm', '確認保留', '確定要保留此帳號嗎？', async () => {
    const response = await fetch(`https://api.mcvanuatu.com/api/accounts/${id}/keepAccount`, {
      method: "GET"
    });
    if (!response.ok) throw new Error("保留失敗");
	setAccounts(prev => prev.filter(account => account.id !== id));
	setSuccessMessage("成功保留該帳號");
    return true; // 成功返回，会自动关闭模态框
  }, 'confirm');
};

// 删除函数 (优化)
const handleDelete = async (id) => {
  showFeedback('confirm', '確認刪除', '確定要刪除此紀錄嗎？', async () => {
    const response = await fetch(`https://api.mcvanuatu.com/api/accounts/${id}`, {
      method: "DELETE",
    });
    if (!response.ok) throw new Error("刪除失敗");
    setAccounts(prev => prev.filter(account => account.id !== id));
	setSuccessMessage("成功删除該帳號");
    return true; // 成功返回，会自动关闭模态框
  }, 'delete');
};

// 延長時間函數 (优化)
const handlePushOneMoreDay = async (id) => {
  showFeedback('confirm', '延長啟用時間', '確定要延長此帳號的啟用時間嗎？', async () => {
    const response = await fetch(`https://api.mcvanuatu.com/api/accounts/${id}/pushOneMoreDay`, {
      method: "GET"
    });
    if (!response.ok) throw new Error("延長失敗");
	setAccounts(prev => prev.filter(account => account.id !== id));
	setSuccessMessage("成功延長該帳號");
    return true; // 成功返回，会自动关闭模态框
  }, 'clock');
};


const handleSuccess = () => {
  showFeedback('info', '操作成功', '設定已保存', null, 'success');
};

// 警告提示示例
const showWarning = () => {
  showFeedback('info', '注意', '此操作不可逆', null, 'warning');
};



// 設置設備函數 (已优化)
const handleSetDevice = async (id, newDevice) => {
  if (newDevice === "選擇設備") return;

  const originalAccount = accounts.find(acc => acc.id === id);
  const originalDevice = originalAccount?.device;

  try {
    showFeedback('processing', '處理中', '設備設定更新中...');
    
    const response = await fetch(`https://api.mcvanuatu.com/api/accounts/${id}/setDevice`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ device: newDevice }),
    });

    if (!response.ok) throw new Error("設置設備失敗");
    
    setAccounts(prev => 
      prev.map(acc => 
        acc.id === id ? { ...acc, device: newDevice } : acc
      )
    );
    setSuccessMessage("成功設置帳號");
	
    return `設備已成功設置為 ${newDevice}`;
    
  } catch (err) {
    setAccounts(prev => 
      prev.map(acc => 
        acc.id === id ? { ...acc, device: originalDevice } : acc
      )
    );
    throw new Error(`設置失敗: ${err.message}`);
  }
};
  
const handleSetAccount = async (device, discountType) => {
  try {
    const response = await fetch("https://api.mcvanuatu.com/api/accounts/setDevice", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        device: String(device),
        discountType: discountType
      }),
    });

    if (!response.ok) throw new Error("設置失敗");
	fetchAccounts();
	setSuccessMessage("成功設置帳號");
    return "帳戶已經成功設置";
  } catch (err) {
    showFeedback('info', '發生錯誤', `操作失敗: ${err.message}`, null, 'warning');
  }
};

  const toggleQrVisibility = (id) => {
    setQrVisible((prev) => ({ ...prev, [id]: !prev[id] }));
  };
  

const handleEmailVerification = async (email) => {
  setEmailVerification(p => ({ ...p, [email]: "loading" }));
  
  try {
    const response = await fetch("https://mailcode.mcvanuatu.com/get-latest-verification-code", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ 
        email_address: email,
        password: "xber1314po"
      }),
    });

    if (!response.ok) throw new Error("驗證碼獲取失敗");
    
    const data = await response.json();
    
    // 先更新验证码再启动倒计时
    setEmailVerification(p => ({ ...p, [email]: data.verification_code }));
    
    // 添加5秒倒计时（在验证码显示后开始）
    setTimeout(() => {
      setEmailVerification(p => {
        const { [email]: _, ...rest } = p;
        return rest;
      });
    }, 5000);

  } catch (err) {
    setEmailVerification(p => ({ ...p, [email]: "error" }));
  }
};

  const devices = ["2", "3", "4", "5", "6", "7", "8", "9"];
  const discountTypes = [
  ...new Set(accounts.map(acc => acc.discountType).filter(type => type !== null && type !== undefined))
].sort((a, b) => a - b).map(String);  // 轉換為字串
  
  
  
  const deviceCards = devices.map((device) => ({
    device,
    account: accounts.find((acc) => acc.device === device),
  }));
	const tableData = accounts.filter(account => 
	  !account.device && 
	  (selectedDiscount === 'all' || String(account.discountType) === selectedDiscount)
	);

  if (loading) return <p className="text-center">載入中...</p>;
  if (error) return <p className="text-center text-red-500">錯誤：{error}</p>;

  return (
	<>
	<ModernModal />
	
        {/* 成功提示 */}
        <AnimatePresence>
          {successMessage && (
            <motion.div
              key="success"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 50 }}
              className={`fixed top-6 right-6 px-4 py-2.5 rounded-md flex items-center gap-2 ${
                darkMode ? "bg-green-900/30 text-green-400" : "bg-green-100 text-green-600"
              } shadow-lg z-50 backdrop-blur-sm`}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <CheckCircle size={18} className="shrink-0" />
              <span className="font-medium">{successMessage}</span>
            </motion.div>
          )}
        </AnimatePresence>
	
    <div className={`p-6 rounded-xl shadow-2xl ${darkMode ? "bg-[#1E1E1E]" : "bg-white"}`}>
      {/* 標題區域 */}
      <div className="flex items-center mb-8 space-x-4">
        <h2 className="text-3xl font-bold bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
          Uber 帳戶管理
        </h2>
          <div className={`flex items-center px-4 py-2 rounded-lg transition-colors ${
            darkMode ? "bg-[#2C2C2C] hover:bg-[#363636]" : "bg-gray-100 hover:bg-gray-200"
          }`}>
            <ShieldCheck size={18} className="mr-2 text-green-400" />
            <span className={`font-medium ${darkMode ? "text-gray-300" : "text-gray-700"}`}>
              已完成訂單: {total404Count}
            </span>
          </div>
      </div>

      {/* 卡片區域 */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
        {deviceCards.map(({ device, account }) => (
          <motion.div
            key={device}
            className={`p-6 rounded-2xl shadow-xl transition-all duration-300 ${
              darkMode ? "bg-[#2C2C2C] hover:bg-[#363636]" : "bg-gray-50 hover:bg-gray-100"
            }`}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
          >
            {/* 設備標題行添加刪除按鈕 */}
            <div className="flex items-center justify-between mb-4 relative pl-3">
              <div className="flex items-center">
                <div className="absolute left-0 w-1 h-full bg-gradient-to-b from-blue-400 to-purple-500 rounded-full" />
                <div className={`h-3 w-3 rounded-full ${
                  account ? 'animate-pulse bg-green-400' : 'bg-gray-500'
                } mr-3`} />
                <h3 className="text-xl font-semibold bg-gradient-to-r from-blue-300 to-purple-400 bg-clip-text text-transparent">
                  設備 #{device}
                </h3>
              </div>
{account && (
  <button
    onClick={() => handleDelete(account.id)}
    className={`group p-1.5 rounded-full border relative transition-all duration-200
      ${
        darkMode 
          ? "border-red-300/30 hover:border-red-300/60 text-red-300/90 hover:text-red-200 bg-gradient-to-b from-[#2C2C2C] to-[#1E1E1E]"
          : "border-red-400/40 hover:border-red-500/60 text-red-500/90 bg-gradient-to-b from-gray-50 to-white"
      }
      shadow-sm hover:shadow-md
      hover:-translate-y-0.5`}
  >
    {/* 內圈光暈效果 */}
    <div className={`absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 
      ${
        darkMode 
          ? "bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-red-400/20 to-transparent" 
          : "bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-red-300/30 to-transparent"
      }`}
    />
    
    {/* 圖標容器 */}
    <div className="relative z-10 transform transition-transform duration-200 group-hover:scale-110">
      <Trash size={18} className="shrink-0" />
    </div>

    {/* 懸浮時外圈動效 */}
    <div className={`absolute -inset-1 rounded-full opacity-0 group-hover:opacity-100 
      ${
        darkMode 
          ? "border border-red-300/20 animate-ping-slow" 
          : "border border-red-400/30 animate-ping-slow"
      }`}
    />
  </button>
)}
            </div>

{account ? (
  <div className="space-y-4">
    {/* 帳號資訊 */}
    <div>
<div className="flex justify-between items-start">
<div 
  className="group relative inline-flex items-center cursor-pointer"
  onClick={() => handleCopy(account.number, account.id, 'number')}
>
  <p className="text-sm font-mono text-blue-300 hover:text-blue-400 transition-colors">
    {account.number}
  </p>

  {/* 複製提示 */}
  {copiedItem?.id === account.id && copiedItem?.type === 'number' && (
    <div
      className={`absolute -top-8 left-1/2 -translate-x-1/2 px-2 py-1 rounded-md text-xs flex items-center ${
        darkMode ? 'bg-gray-700 text-green-400' : 'bg-gray-100 text-green-600'
      } shadow-lg`}
    >
      <span>已</span>
      <span>複</span>
      <span>製</span>
    </div>
  )}
</div>
  {account.discountType && (
    <div className={`ml-2 px-2 py-1 rounded-md text-xs font-medium -translate-y-1 ${
      account.discountType === 99 
        ? (darkMode 
            ? "bg-green-800/30 text-green-400" 
            : "bg-green-200 text-green-700")
        : (darkMode 
            ? "bg-purple-800/30 text-purple-400" 
            : "bg-purple-200 text-purple-700")
    }`}>
      {account.discountType === 99 ? "現金卷" : "支付寶"}
    </div>
  )}
</div>
<div 
  className="relative group inline-flex items-center cursor-pointer"
  onClick={() => handleCopy(account.email, account.id, 'email')} // 點擊電郵觸發複製
>
  <p className={`text-xs mt-1 ${darkMode ? "text-gray-400 hover:text-gray-200" : "text-gray-600 hover:text-gray-800"} transition-colors`}>
    {account.email}
  </p>

  {/* 複製提示 */}
  {copiedItem?.id === account.id && copiedItem?.type === 'email' && (
    <div
      className={`absolute -top-8 left-1/2 -translate-x-1/2 px-2 py-1 rounded-md text-xs flex items-center ${
        darkMode ? 'bg-gray-700 text-green-400' : 'bg-gray-100 text-green-600'
      } shadow-lg`}
    >
      <span>已</span>
      <span>複</span>
      <span>製</span>
    </div>
  )}
</div>
      <p className="text-xs opacity-75 mt-2">
        🕒 {new Date(account.createdTime).toLocaleString()}
      </p>
    </div>

    {/* 驗證與QR組合區塊 */}
    <div className="space-y-4">
      {/* 郵件驗證按鈕及結果 */}
<div className="space-y-4">
      {/* 验证按钮 */}
      <button
        onClick={() => handleEmailVerification(account.email)}
        className={`w-full py-2.5 rounded-xl font-medium flex items-center justify-center gap-2 ${
          darkMode
            ? "bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500"
            : "bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-400 hover:to-purple-400"
        } text-white transition-all`}
      >
        <MailCheck size={18} />
        郵件驗證
      </button>

      <AnimatePresence>
        {emailVerification[account.email] && (
          <motion.div
            key={`verification-${account.id}`}
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="relative overflow-visible"
          >
            <div
              className={`p-3 rounded-lg mt-2 border-2 backdrop-blur-sm ${
                emailVerification[account.email] === "error"
                  ? "bg-red-500/20 border-red-500/30"
                  : emailVerification[account.email] === "loading"
                  ? "bg-blue-500/20 border-blue-500/30"
                  : "bg-green-500/20 border-green-500/30"
              }`}
            >
              {/* 动态进度条 */}
              {emailVerification[account.email] !== "error" &&
                emailVerification[account.email] !== "loading" && (
                  <motion.div
                    initial={{ scaleX: 1 }}
                    animate={{ scaleX: 0 }}
                    transition={{ duration: 5, ease: "linear" }}
                    className={`absolute bottom-0 left-0 right-0 h-1 ${
                      emailVerification[account.email] === "loading"
                        ? "bg-blue-400/30"
                        : "bg-green-400/30"
                    } origin-left`}
                    style={{ borderRadius: "0 0 8px 8px" }}
                  />
                )}

              <div className="relative group">
                {emailVerification[account.email] === "loading" ? (
                  <div className="flex items-center">
                    <motion.div
                      animate={{ rotate: 360 }}
                      transition={{ repeat: Infinity, duration: 1 }}
                      className="w-4 h-4 border-2 border-blue-400 rounded-full border-t-transparent mr-2"
                    />
                    <span className="text-sm text-blue-400">
                      驗證碼獲取中...
                    </span>
                  </div>
                ) : emailVerification[account.email] === "error" ? (
                  <span className="text-sm text-red-400">
                    ⚠️ 驗證失敗，請重試
                  </span>
                ) : (
                  <div className="relative">
                    {/* 邮件验证按钮 */}
                    <button
                      onClick={() =>
                        handleCopy(
                          emailVerification[account.email],
                          account.id,
                          "verificationCode"
                        )
                      }
                      className="flex items-center gap-2 w-full relative z-10"
                    >
                      <CheckCircle2 className="w-4 h-4 shrink-0 align-middle text-green-400" />
                      <span className="text-sm text-green-400">
                        驗證碼: {emailVerification[account.email]}
                      </span>
                    </button>

                    {/* 已複製提示 */}
                    {copiedItem?.id === account.id &&
                      copiedItem?.type === "verificationCode" && (
                        <div
                          className={`absolute -top-10 left-1/2 -translate-x-1/2 px-3 py-1 rounded-md text-xs ${
                            darkMode
                              ? "bg-gray-700 text-green-400"
                              : "bg-gray-100 text-green-600"
                          } shadow-lg z-50 flex items-center pointer-events-none`}
                        >
                          <span>已複製</span>
                        </div>
                      )}
                  </div>
                )}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
</div>

      {/* 整合按鈕行 */}
<div className="flex flex-col sm:flex-row gap-2.5">
  {/* QR 控制按鈕 */}
  <div className="relative group flex-1">
    <button
      onClick={() => toggleQrVisibility(account.id)}
      className={`w-full py-2 rounded-xl font-medium flex items-center justify-center gap-2
        bg-gradient-to-r ${darkMode 
          ? "from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800" 
          : "from-gray-200 to-gray-300 hover:from-gray-300 hover:to-gray-400"}
        shadow-lg hover:shadow-xl transition-all duration-300`}
    >
      <QrCode size={18} />
      <span className="hidden xs:inline">
        {qrVisible[account.id] ? "收起QR" : "展開QR"}
      </span>
    </button>
    <div className={`absolute -top-8 left-1/2 -translate-x-1/2 px-2 py-1 rounded-lg text-xs
      ${darkMode ? 'bg-gray-700 text-gray-200' : 'bg-gray-200 text-gray-700'} 
      opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none
      shadow-md whitespace-nowrap`}>
      切換 QR 顯示
    </div>
  </div>

  {/* 延長按鈕 */}
  <div className="relative group flex-1">
    <button
      onClick={() => handlePushOneMoreDay(account.id)}
      className={`w-full py-2 rounded-xl font-medium flex items-center justify-center gap-2 
        bg-gradient-to-r ${darkMode 
          ? "from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700" 
          : "from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600"}
        shadow-lg hover:shadow-xl transition-all duration-300`}
    >
      <Clock size={18} />
      <span className="hidden xs:inline">延長</span>
    </button>
    <div className={`absolute -top-8 left-1/2 -translate-x-1/2 px-2 py-1 rounded-lg text-xs
      ${darkMode ? 'bg-gray-700 text-gray-200' : 'bg-gray-200 text-gray-700'} 
      opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none
      shadow-md whitespace-nowrap`}>
      延長帳號有效期
    </div>
  </div>

  {/* 保留按鈕 */}
  <div className="relative group flex-1">
    <button
      onClick={() => handleKeepAccount(account.id)}
      className={`w-full py-2 rounded-xl font-medium flex items-center justify-center gap-2 
        bg-gradient-to-r ${darkMode 
          ? "from-yellow-600 to-amber-600 hover:from-yellow-700 hover:to-amber-700" 
          : "from-yellow-500 to-amber-500 hover:from-yellow-600 hover:to-amber-600"}
        shadow-lg hover:shadow-xl transition-all duration-300`}
    >
      <ShieldCheck size={18} />
      <span className="hidden xs:inline">保留</span>
    </button>
    <div className={`absolute -top-8 left-1/2 -translate-x-1/2 px-2 py-1 rounded-lg text-xs
      ${darkMode ? 'bg-gray-700 text-gray-200' : 'bg-gray-200 text-gray-700'} 
      opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none
      shadow-md whitespace-nowrap`}>
      永久保留此帳號
    </div>
  </div>
</div>

      {/* QR顯示區域 */}
      <AnimatePresence>
        {qrVisible[account.id] && (
          <motion.div
            key={`qr-${account.id}`}
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.25 }}
            className="overflow-hidden"
          >
            <div className={`p-3 border-2 rounded-xl ${darkMode ? "border-[#363636] bg-[#2C2C2C]" : "border-gray-200 bg-gray-100"}`}>
              {account.alipayQrCode ? (
<img
  src={`data:image/png;base64,${account.alipayQrCode}`}
  alt="QR Code"
  className="w-full aspect-square object-cover rounded-lg"  // 新增rounded-lg
  onError={(e) => e.target.style.display = 'none'}
/>
              ) : (
                <div className="text-center py-4 text-gray-400 text-sm">
                  暫無數據
                </div>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  </div>
) : (
<div className="flex flex-col gap-4 py-4">
    <button
      onClick={() => handleSetAccount(device, "99")}
      className={`group relative py-2.5 rounded-xl font-medium flex items-center justify-center gap-2 
        bg-gradient-to-r transition-all duration-300
        ${darkMode 
          ? "from-green-700 to-emerald-700 hover:from-green-600 hover:to-emerald-600" 
          : "from-green-500 to-emerald-400 hover:from-green-400 hover:to-emerald-300"}
        shadow-lg hover:shadow-xl`}
    >
      <span className="relative z-10">現金券</span>
      <div className={`absolute inset-0 rounded-xl opacity-0 group-hover:opacity-20 ${
        darkMode ? "bg-white" : "bg-gray-100"
      } transition-opacity`}/>
    </button>

    <button
      onClick={() => handleSetAccount(device, "100")}
      className={`group relative py-2.5 rounded-xl font-medium flex items-center justify-center gap-2 
        bg-gradient-to-r transition-all duration-300
        ${darkMode 
          ? "from-blue-700 to-purple-700 hover:from-blue-600 hover:to-purple-600" 
          : "from-blue-500 to-purple-400 hover:from-blue-400 hover:to-purple-300"}
        shadow-lg hover:shadow-xl`}
    >
      <span className="relative z-10">支付寶</span>
      <div className={`absolute inset-0 rounded-xl opacity-0 group-hover:opacity-20 ${
        darkMode ? "bg-white" : "bg-gray-100"
      } transition-opacity`}/>
    </button>
  </div>
)}
          </motion.div>
        ))}
      </div>
	  
	  
{/* 日期查询卡片 */}
<div className={`p-4 rounded-xl space-y-4 ${darkMode ? "bg-[#2C2C2C]" : "bg-gray-100"}`}>
  {/* 第一行：日期选择器 + 快捷按钮 */}
  <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
    {/* 开始日期 */}
<div className="md:col-span-2 relative group">
  <label className={`block text-sm mb-2 flex items-center gap-1.5 ${
    darkMode ? "text-purple-300/90" : "text-purple-600"
  }`}>
    <CalendarDays className="w-4 h-4" /> {/* 需从lucide-react导入图标 */}
    開始日期
  </label>
  <div className="relative">
    <input
      type="date"
      value={timeFilter.start}
      onChange={(e) => setTimeFilter(p => ({ ...p, start: e.target.value }))}
      className={`w-full px-4 py-2.5 rounded-xl border-2 focus:ring-0 font-medium transition-all duration-300
        ${
          darkMode 
            ? "bg-[#363636] border-[#404040] hover:border-purple-500/50 focus:border-purple-400 text-gray-200" 
            : "bg-white border-gray-200 hover:border-purple-300 focus:border-purple-400 text-gray-700"
        }
        shadow-sm hover:shadow-md focus:shadow-lg`}
    />
    {/* 动态边框光效 */}
    <div className={`absolute -inset-0.5 rounded-xl bg-gradient-to-r from-purple-400/30 to-pink-400/30 
      opacity-0 group-hover:opacity-30 group-focus-within:opacity-50 blur-[6px] pointer-events-none 
      transition-opacity duration-300`} />
  </div>
</div>

{/* 结束日期 */}
<div className="md:col-span-2 relative group">
  <label className={`block text-sm mb-2 flex items-center gap-1.5 ${
    darkMode ? "text-blue-300/90" : "text-blue-600"
  }`}>
    <CalendarCheck className="w-4 h-4" /> {/* 需从lucide-react导入图标 */}
    結束日期
  </label>
  <div className="relative">
    <input
      type="date"
      value={timeFilter.end}
      onChange={(e) => setTimeFilter(p => ({ ...p, end: e.target.value }))}
      className={`w-full px-4 py-2.5 rounded-xl border-2 focus:ring-0 font-medium transition-all duration-300
        ${
          darkMode 
            ? "bg-[#363636] border-[#404040] hover:border-blue-500/50 focus:border-blue-400 text-gray-200" 
            : "bg-white border-gray-200 hover:border-blue-300 focus:border-blue-400 text-gray-700"
        }
        shadow-sm hover:shadow-md focus:shadow-lg`}
    />
    {/* 动态边框光效 */}
    <div className={`absolute -inset-0.5 rounded-xl bg-gradient-to-r from-blue-400/30 to-cyan-400/30 
      opacity-0 group-hover:opacity-30 group-focus-within:opacity-50 blur-[6px] pointer-events-none 
      transition-opacity duration-300`} />
  </div>
</div>

{/* 重設按鈕 */}
<button
  onClick={() => setTimeFilter({ start: "", end: "" })}
  className={`flex items-center justify-center gap-1.5 px-4 py-2 rounded-lg 
    transition-all duration-200 border ${
      darkMode
        ? "border-red-400/40 hover:border-red-300/60 text-red-300 hover:bg-red-900/20"
        : "border-red-300/50 hover:border-red-400/60 text-red-500 hover:bg-red-50"
    }
    shadow-sm hover:shadow-md hover:-translate-y-0.5`}
>
  <RotateCcw size={16} className="shrink-0" /> {/* 需要从lucide-react导入图标 */}
  <span className="text-sm font-medium">重置</span>
  
  {/* 悬浮光晕效果 */}
  <div className={`absolute inset-0 rounded-lg opacity-0 hover:opacity-20 
    ${darkMode ? "bg-red-400/10" : "bg-red-300/10"} 
    transition-opacity pointer-events-none`} />
</button>

  </div>

  {/* 第二行：统计结果 */}
	<div className="flex items-center justify-between px-2">
	  <span className={`text-sm ${darkMode ? "text-gray-400" : "text-gray-600"}`}>
		選擇範圍：{timeFilter.start || '開始'} 至 {timeFilter.end || '結束'}
	  </span>
	  <div className="flex items-center gap-2">
		<span>🕒 </span>
		<span className="text-lg font-semibold bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
		  該時間段完成的訂單：
		</span>
		<div className="relative group">
		  <div className={`absolute rounded-full blur opacity-15 transition-all 
			duration-300 group-hover:opacity-50 ${
			  darkMode ? "bg-green-400" : "bg-green-600"
			}`}
		  />
		  <span className={`relative z-10 flex items-center justify-center
			text-2xl font-bold transition-all duration-300
			${
			  darkMode 
				? "text-green-400 hover:text-green-300" 
				: "text-green-600 hover:text-green-700"
			}
			group-hover:scale-105`}
		  >
			<span className="bg-gradient-to-r from-green-500/20 to-emerald-400/20 rounded-full px-3 py-1">
			  {filteredCount}
			</span>
		  </span>
		</div>
	  </div>
	</div>
</div>

    </div>
			<div className="mt-2 pt-4">
		  <SMS darkMode={darkMode} />
		</div>
	</>
  );
}

export default UberAccount;
